import { api } from "../api";
import { CommandType } from "../../../types/types";

/**
 * findAllCommandsByDeviceIdListResponse - Function that finds on database all commands suported by device as select list response
 * /devices/commands/{deviceId}}  
 * method GET 
 * @async-function
 */
const findAllCommandsByDeviceIdListResponse = async (token: string, managerId: number, deviceId: number, deviceType: string) => {
    const response = await api.get<Array<CommandType>>(
        `/devices/commands/${managerId}/${deviceId}?deviceType=${deviceType}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
    );
    return response;
};

const findAllCommandsByPlateListResponse = async (token: string, managerId: number, plate: string, deviceType: string) => {
    const response = await api.get<Array<CommandType>>(
         `/devices/commands/${managerId}/-1?plate=${plate}&deviceType=${deviceType}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
    );
    return response;
}

export  { findAllCommandsByDeviceIdListResponse, findAllCommandsByPlateListResponse };
